var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoInvitation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 160,
    viewBox: "0 0 200 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "mau4frczja",
    d: "M0 124.805L163.975 124.805 163.975 0.032 0 0.032z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "7ewn1lewsc",
    d: "M0 0.113L105.921 0.113 105.921 10.398 0 10.398z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "0yy85eysce",
    d: "M0 120.002L105.921 120.002 105.921 0 0 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H200V160H0z",
    transform: "translate(-1594 -512) translate(32 22) translate(1562 490)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.574
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E3EEFF",
    d: "M111.396 124.805L119.648 124.805 119.648 74.264 111.396 74.264z",
    transform: "translate(-1594 -512) translate(32 22) translate(1562 490) translate(15 8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3EEFF",
    d: "M114.338 109.333L115.522 108.767 105.36 87.673 104.176 88.24z",
    transform: "translate(-1594 -512) translate(32 22) translate(1562 490) translate(15 8)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1594 -512) translate(32 22) translate(1562 490) translate(15 8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E3EEFF",
    d: "M111.956 90.99s1.421 6.996 8.99 4.934c3.31-.902 4.03-3.389 3.867-5.766 3.057 2.18 7.66 3.954 7.215-5.604 0 0 9.862 7.514 13.168-3.29 3.306-10.804-5.546-11.821-5.546-11.821s12.45-10.288 8.2-18.72c-4.578-9.085-12.552-4.387-12.552-4.387s1.649-12.043-7.253-11.524c-1.143.066-2.193.562-2.977 1.345-3.048-1.619-6.897 3.326-6.897 3.326s-.766-6.06-6.819-3.873c-2.647.957-3.338 3.172-3.329 5.248-2.294-1.757-5.823-3.08-5.952 5.274 0 0-7.375-6.09-10.517 3.545-3.14 9.635 3.766 10.082 3.766 10.082s-10.303 9.642-7.386 16.82c3.142 7.731 9.646 3.214 9.646 3.214s-1.589 8.914 3.535 9.725c-.321 1.806.43 3.7 2.06 4.66 4.06 2.395 8.781-3.188 8.781-3.188"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F8FF",
    d: "M158.154 75.599L158.154 124.805 14.464 124.805 14.464 75.422 76.346 67.043z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3EEFF",
    d: "M76.346 67.043L14.465 75.422 14.465 124.803 76.346 124.803z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1E3FF",
    d: "M82.849 124.803L112.361 124.803 112.361 86.952 82.849 86.952z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "tz5qi7maib",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mau4frczja"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E3EEFF",
    d: "M84.241 124.803L110.969 124.803 110.969 88.227 84.241 88.227z",
    mask: "url(#tz5qi7maib)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1E3FF",
    d: "M97.492 124.803L97.785 124.803 97.785 88.227 97.492 88.227zM163.725 77.392L76.365 68.256 8.935 77.388 8.611 74.999 76.328 65.829 76.472 65.844 163.975 74.995z",
    mask: "url(#tz5qi7maib)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F8FF",
    d: "M157.495 20.003c2.33-5.035.48-8.62-5.215-8.62-3.571 0-8 1.412-12.312 3.709-.487-1.31-1.859-2.094-4.066-2.094-3.885 0-9.24 2.424-13.44 5.846-1.018-.763-2.488-1.23-4.378-1.305-3.718-.155-8.221 1.238-12.136 3.505-.34-.38-.92-.618-1.723-.653-2.143-.088-5.043 1.318-6.484 3.14-.09.114-.169.224-.249.334h62.896c1.987-1.784-.21-3.772-2.893-3.862M68.912 6.55c-.156-.017-.314-.025-.475-.025.148-1.647-.705-2.698-2.527-2.698-1.315 0-2.928.549-4.572 1.478.47-3.196-1.036-5.273-4.448-5.273-2.751 0-6.235 1.35-9.677 3.555-.301-1.254-1.315-2.006-3.018-2.006-2.993 0-7.246 2.322-10.655 5.598 0 0-.001.004-.004 0-.737-.73-1.844-1.182-3.299-1.254-2.85-.147-6.388 1.187-9.525 3.36-.239-.367-.673-.595-1.295-.624-1.558-.08-3.705 1.119-4.953 2.723H71.421c1.336-2.432.271-4.56-2.509-4.834M11.178 124.803H5.063S1.3 121.459.074 116.97c-.564-2.067 2.212-3.495 3.893-2.018 3.934 3.459 7.21 9.85 7.21 9.85",
    mask: "url(#tz5qi7maib)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F8FF",
    d: "M13.752 124.803H7.638S4.14 117.62 5.492 112.39c.469-1.814 2.742-2.373 4.001-.987 4.626 5.088 4.26 13.399 4.26 13.399M13.76 124.803h3.945s2.478-4.365 4.802-9.73c2.168-5.002-1.528-7.093-3.849-2.175-2.952 6.255-4.899 11.905-4.899 11.905",
    mask: "url(#tz5qi7maib)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F8FF",
    d: "M14.839 124.803h6.114s6.157-2.913 5.813-8.427c-.09-1.443-1.74-2.38-3.2-1.821-6.563 2.516-8.727 10.248-8.727 10.248",
    mask: "url(#tz5qi7maib)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F8FF",
    d: "M11.406 124.803h6.115s1.847-10.2-.343-16.627c-.654-1.92-2.981-2.255-4.053-.586-3.985 6.204-1.719 17.213-1.719 17.213",
    mask: "url(#tz5qi7maib)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1E3FF",
    d: "M29.325 113.73L61.486 113.73 61.486 80.746 29.325 80.746z",
    mask: "url(#tz5qi7maib)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5FCFF",
    d: "M30.837 112.032L59.975 112.032 59.975 82.444 30.837 82.444z",
    mask: "url(#tz5qi7maib)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1E3FF",
    d: "M29.95 98.378L60.861 98.378 60.861 96.098 29.95 96.098z",
    mask: "url(#tz5qi7maib)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1E3FF",
    d: "M44.266 113.131L46.545 113.131 46.545 81.344 44.266 81.344zM158.156 113.73L121.688 113.73 121.688 81.344 158.156 81.344",
    mask: "url(#tz5qi7maib)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5FCFF",
    d: "M123.17 112.063L158.156 112.063 158.156 83.012 123.17 83.012z",
    mask: "url(#tz5qi7maib)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M102.072 78.332c0 2.467-2 4.467-4.467 4.467-2.467 0-4.467-2-4.467-4.467 0-2.468 2-4.468 4.467-4.468 2.467 0 4.467 2 4.467 4.468",
    mask: "url(#tz5qi7maib)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1E3FF",
    d: "M54.412 124.805L118.207 124.805 118.207 123.661 54.412 123.661z",
    mask: "url(#tz5qi7maib)"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.535,
    transform: "translate(-1594 -512) translate(32 22) translate(1562 490) translate(68 31)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 109.604)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hl60fuuiud",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7ewn1lewsc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F6FF",
    d: "M105.92 5.256c0 2.84-23.71 5.142-52.96 5.142C23.712 10.398 0 8.096 0 5.256 0 2.416 23.711.113 52.96.113c29.25 0 52.96 2.303 52.96 5.143",
    mask: "url(#hl60fuuiud)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "sr4dlykyjf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0yy85eysce"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F1A34F",
    d: "M50.128 114.86L55.697 114.86 55.697 39.367 50.128 39.367z",
    mask: "url(#sr4dlykyjf)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C95C12",
    d: "M50.128 39.367L55.697 39.367 55.697 44.936 50.128 42.886z",
    mask: "url(#sr4dlykyjf)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D86713",
    d: "M44.117 21.254c0-7.357-5.964-13.321-13.32-13.321-7.358 0-13.322 5.964-13.322 13.32v18.113h26.642V21.254z",
    mask: "url(#sr4dlykyjf)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C95C12",
    d: "M14.952 47.137c-1.78 7.357 2.741 13.321 10.098 13.321 7.358 0 14.765-5.964 16.545-13.32l1.853-7.661c.107-.442-.227-.867-.682-.867H17.568c-.324 0-.606.222-.682.537l-1.934 7.99z",
    mask: "url(#sr4dlykyjf)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1A34F",
    d: "M13.88 47.137c-1.78 7.357 2.741 13.321 10.098 13.321 7.357 0 14.765-5.964 16.545-13.32l1.853-7.661c.107-.442-.228-.867-.682-.867H16.496c-.324 0-.606.222-.683.537l-1.933 7.99zM75.474 21.252v18.116H44.116V21.252c0-3.084-1.044-5.917-2.806-8.174-2.434-3.134-6.24-5.146-10.513-5.146h31.357c4.274 0 8.08 2.012 10.513 5.146 1.762 2.257 2.807 5.09 2.807 8.174",
    mask: "url(#sr4dlykyjf)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFCBAB",
    d: "M75.474 21.252v4.845H44.116v-4.845c0-3.084-1.044-5.917-2.806-8.174h31.357c1.762 2.257 2.807 5.09 2.807 8.174",
    mask: "url(#sr4dlykyjf)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D86713",
    d: "M48.482 28.43V1.646c0-1.016.912-1.79 1.914-1.624l6.42 1.061c.475.079.824.49.824.972v1.661c0 .544-.44.985-.985.985h-6.13V28.43c0 .564-.457 1.021-1.021 1.021-.564 0-1.022-.457-1.022-1.021",
    mask: "url(#sr4dlykyjf)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInvitation);
export default __webpack_public_path__ + "static/media/no-invitation.dac1501b8877c9349ab75b4fb7752c6b.svg";
export { ForwardRef as ReactComponent };